// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button.large.try-again{margin:.857143rem 0}.slot-stage{min-height:1px}.hide-options{max-height:15vh;overflow:hidden}.learn-more-content{height:100%;width:100%;background-color:#fff;z-index:1;padding:1rem 2rem}", ""]);
// Exports
module.exports = exports;
